import Typography from "@/src/views/components/Typography";
import styles from "./index.module.scss";
import CardLayanan from "../CardLayanan";
import PointLine from "@/src/views/components/Icon/icons/PointLine";
import { Fragment, useEffect, useRef } from "react";
import Skeleton from "@/src/views/components/Skeleton";
import Mosaics2 from "@/src/views/components/Icon/icons/Mosaics2";
import Mosaics3 from "@/src/views/components/Icon/icons/Mosaics3";
import { Service, WordStyling } from "@/src/types/landingPage";

export default function LandingServices({
  services,
  loading,
  listWordStyling,
}: {
  services: Service[];
  loading: boolean;
  listWordStyling: WordStyling[];
}) {
  const mosaics2Ref = useRef(null);
  const mosaics3Ref = useRef(null);
  const pointLineRef = useRef(null);
  const titleRef = useRef(null);

  useEffect(() => {
    const options = {
      root: null, // use the viewport as the root
      rootMargin: '0px',
    };

    const callback: IntersectionObserverCallback = (
      entries: IntersectionObserverEntry[],
      observer: IntersectionObserver,
    ) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          entry.target.classList.add(styles["visible"]);
          observer.unobserve(entry.target)
        }
      });
    };
    const observer = new IntersectionObserver(callback, options);
  
    if (mosaics2Ref.current) {
      observer.observe(mosaics2Ref.current);
    }
    if (mosaics3Ref.current) {
      observer.observe(mosaics3Ref.current);
    }
    if (pointLineRef.current) {
      observer.observe(pointLineRef.current);
    }
    if (titleRef.current) {
      observer.observe(titleRef.current);
    }
    // Clean up
    return () => {
      observer.disconnect();
    };
  }, [
    mosaics2Ref,
    mosaics3Ref,
    pointLineRef,
    titleRef,
  ]);

  return (
    <div
      className={styles["main-service-section"]}
    >
      <Mosaics2 className={styles["mosaics-2-wrapper"]} svgRef={mosaics2Ref}/>
      <Mosaics3 className={styles["mosaics-3-wrapper"]} svgRef={mosaics3Ref}/>
      <PointLine className={styles["point-line"]} svgRef={pointLineRef} />
      <div
        ref={titleRef}
        className={styles["main-service-title"]}
      >
        <div>
          <Typography variant="heading-5-bold" color="black">
            3 Layanan Utama&nbsp;
          </Typography>
          <Typography variant="heading-5-bold" color="orange1">
            BRIBrain
          </Typography>
        </div>
        <div style={{ textAlign: "center" }}>
          <Typography variant="heading-2-medium" color="dark40">
            Layanan ini disajikan dalam bentuk hasil data, API, dan&nbsp;
          </Typography>
          <Typography variant="heading-2-medium" color="dark40" fontStyle="italic">
            Webview
          </Typography>
        </div>
      </div>
      <div className={styles["services-box-wrapper"]}>
        {services?.map((item, id) => (
          <Fragment key={id}>
            {loading ? (
              <Skeleton width={"100%"} height={250} radius={"24px"} />
            ) : (
              <CardLayanan
                src={`${process.env.NEXT_PUBLIC_IMAGES}/${item?.logo_layanan_utama}`}
                field={item?.title_layanan_utama}
                desc={item?.summary_layanan_utama}
                listWordStyling={listWordStyling}
                transitionDelay={`${0.25+id*0.5}s`}
              />
            )}
          </Fragment>
        ))}
      </div>
    </div>
  );
}
